import { createFileRoute } from '@tanstack/react-router';

import { ProjectsOverview } from '@/features/projects/projects';

export const Route = createFileRoute('/_authenticated/projects/')({
  component: ProjectsOverview,
});
